export default Object.freeze({
  Temporary: 0,
  Definitive: 1,
});
